import _ from 'lodash';
import { useMemo } from 'react';
import { Bits, getValueOfEnumKeyResolver } from '@wemogy/reactbase';
import useAuthorizationStore from '../../../../hooks/UseAuthorizationStore';
import { isSinglePermissionAdvancedObject } from '../../../../types/SinglePermission';
export default function createPermissionFeatureWithoutStoreHook() {
    return function (permissionEnum) {
        return function () {
            var _a = useAuthorizationStore(), activePermissionCache = _a.activePermissionCache, config = _a.config;
            var permissionFeatureHookFunctions = useMemo(function () {
                var permissionLevel = _.values(config.permissionLevels).find(function (x) { return x.permissionEnum === permissionEnum; });
                if (!permissionLevel) {
                    console.error('No permission level found for the given permissionEnum! Please check the authorization config', permissionEnum, config);
                    throw new Error('No permission level found for the given permissionEnum! Please check the authorization config');
                }
                var hasPermissionResolver = function (id, permission, valueOfEnumKeyResolver, subLevelIndex) {
                    if (!activePermissionCache) {
                        return false;
                    }
                    var resolveHasPermission = function (permissionValue) {
                        var enumValue = valueOfEnumKeyResolver(permissionValue);
                        return activePermissionCache.hasPermission(permissionLevel.pathIndex, permissionLevel.levelIndex, id, enumValue, subLevelIndex);
                    };
                    if (isSinglePermissionAdvancedObject(permission)) {
                        var allowedPermission = permission.oneOf.find(resolveHasPermission);
                        return allowedPermission !== undefined;
                    }
                    return resolveHasPermission(permission);
                };
                return ({
                    hasPermissionOnSubLevel: function (subLevelName, id, permission) {
                        var subPermissionLevel = config.permissionLevels[subLevelName];
                        var subLevelIndex = subPermissionLevel.levelIndex - permissionLevel.levelIndex;
                        var valueOfEnumKeyResolver = getValueOfEnumKeyResolver(subPermissionLevel.permissionEnum);
                        return hasPermissionResolver(id, permission, valueOfEnumKeyResolver, subLevelIndex);
                    },
                    hasPermission: function (id, permission) {
                        var valueOfEnumKeyResolver = getValueOfEnumKeyResolver(permissionEnum);
                        return hasPermissionResolver(id, permission, valueOfEnumKeyResolver, 0);
                    },
                    hasPermissions: function (id, permissions) {
                        if (!activePermissionCache) {
                            return false;
                        }
                        console.log(permissions);
                        var enumValue = 5; //valueOfEnumKeysResolver(permissions);
                        return activePermissionCache.hasPermission(permissionLevel.pathIndex, permissionLevel.levelIndex, id, enumValue, 0);
                    },
                    getPermissions: function (id) {
                        if (!activePermissionCache) {
                            return new Bits();
                        }
                        return activePermissionCache.getPermissions(permissionLevel.pathIndex, permissionLevel.levelIndex, id, 0);
                    }
                });
            }, [activePermissionCache]);
            return permissionFeatureHookFunctions;
        };
    };
}
//# sourceMappingURL=CreatePermissionFeatureWithoutStoreHook.js.map